<template>
    <div
        v-if="accountList.length"
        class="wx-account-manage wx-account-manage-media"
    >
        <div
            id="scrollWrap"
            class="wx-account-list"
        >
            <div
                v-show="isSroll"
                class="wx-account-list-icon wx-account-list-icon-left"
            >
                <v-button
                    @click="move('right')"
                    remote
                    type="text"
                    size="small"
                    icon="arrow_left_small_line"
                />
            </div>
            <ul
                id="scrollContent"
                class="account-scroll-list"
            >
                <v-card-picker
                    :options="accountList"
                    v-model="currentIndex"
                    @select="handlerSelect"
                    :map="cardMap"
                >
                    <template
                        slot="item"
                        slot-scope="props"
                    >
                        <div class="account-item">
                            <div
                                v-if="+props.item.accountStatus === 2"
                                class="account-item-avator"
                            >
                                <span
                                    v-tip:reading.hover
                                    class="avator-mask"
                                />
                                <v-tip
                                    ref="reading"
                                    kind="small"
                                >
                                    {{ $t('读取中') }}
                                </v-tip>
                            </div>
                            <img :src="props.item.icon ? props.item.icon : (props.item.type == 1 ? wxImg : qqImg)">
                            <div class="account-info">
                                <div class="account-text">
                                    <span class="account-name">{{ props.item.name }}</span>
                                </div>
                                <div class="account-type">
                                    {{ props.item.typeName }}
                                </div>
                            </div>
                        </div>
                    </template>
                </v-card-picker>
            </ul>
            <div
                v-show="isSroll"
                class="wx-account-list-icon wx-account-list-icon-right"
            >
                <v-button
                    @click="move('left')"
                    remote
                    type="text"
                    icon="arrow_right_small_line"
                    size="small"
                />
            </div>
            <v-button
                v-if="!isYx"
                @click="synchronization = true"
                :disabled="asynButtonDisabled || !enabledLen"
                icon="basic_refresh_line"
                remote
                class="wx-account-list-refresh"
            >
                {{ $t('同步') }}
            </v-button>
            <v-dialog
                v-model="synchronization"
                @confirm="handleSynch"
                kind="modal"
                status="confirm"
                class="synchDialog"
            >
                <div slot="title">
                    {{ $t('公众号同步') }}
                </div>
                <AccountSync @change="changeSynchronization" />
                <template slot="footer-actionbar-primary">
                    {{ $t('同步') }}
                </template>
                <template slot="footer-actionbar-cancel">
                    {{ $t('取消') }}
                </template>
            </v-dialog>
            <v-dialog
                v-model="updateOfficial"
                @confirm="synchronizationConfirm"
                :confirm-loading="updateLoading"
                :title="$t('确定同步？')"
                kind="confirm"
            >
                <div>{{ $t('此操作将更新所选公众号的自动回复') }}</div>
            </v-dialog>
            <v-dialog
                v-model="success"
                :status="allStatus == 2 ? 'warning':'success'"
                :title="updateTitle"
                kind="alert"
            >
                <SyncResult :value="updateSucessData" />
            </v-dialog>
        </div>
    </div>
</template>
<script>
import AccountSync from './AccountSync.vue';
import SyncResult from './syncResult.vue';
import Cookie from 'src/utils/cookie';
const replyUrl = {
    keyword: '/mp/keywordReply/keywordReplySync',
    msg: '/mp/msgReply/msgReplySync',
    welcome: '/mp/welcomeReply/replySync',
    menu: '/mp/menu/menuSync',
};
export default {
    name: 'WxAccountManage',
    components: { AccountSync, SyncResult },
    data() {
        return {
            preIndex: 0,
            accountlist: [],
            currentIndex: 0,
            isScroll: false,
            nextNum: 10,
            synchronization: false,
            params: { from: {}, to: [], _bqq_csrf: Cookie.get('_bqq_csrf') },
            updateOfficial: false,
            updateLoading: false,
            success: false,
            allStatus: null,
            updateSucessData: {},
            cardMap: { value: 'accountID', disabled: 'disabled' },
            asynButtonDisabled: false,
            replySyncUrl: '',
            isSroll: false,
            isYx: false,
            // 这个属性不知道之前怎么丢失了，代码状态是不对的，所以补回来
            enabledLen: 0,
        };
    },
    computed: {
        updateTitle() {
            if (this.allStatus !== null) {
                if (this.allStatus === 0 || this.allStatus === 1) {
                    return this.$t('以下公众号已同步成功!');
                }
                if (this.allStatus === 2) {
                    return this.$t('同步失败');
                }
            }
            return '';
        },
    },
    created() {
        this.init();
        this.isYx =  window.data.set.currentClass === 'yx' || window.data.set.current === '10074';
    },
    mounted() {
        if (window.data.data.accountList.length) {
            setInterval(() => {
                this.timerFunc();
            }, 500);
        }
    },
    methods: {
        timerFunc() {
            let contentWidth =  window.document.getElementById('scrollWrap').offsetWidth;
            contentWidth = this.isYx ? contentWidth : contentWidth - 83;
            const pcikerWidth = this.accountList.length * 198 - 16;
            if (pcikerWidth >= contentWidth || pcikerWidth === contentWidth - 64) {
                this.isSroll = true;
                if (this.isYx) {
                    window.document.getElementById('scrollContent').style.width = 'calc(100% - 64px)';
                } else if (!this.isYx) {
                    window.document.getElementById('scrollContent').style.width = 'calc(100% - 146px)';
                }
            } else {
                this.isSroll = false;
                if (this.isYx) {
                    window.document.getElementById('scrollContent').style.width = 'auto';
                } else if (!this.isYx) {
                    window.document.getElementById('scrollContent').style.width = 'calc(100% - 82px)';
                }
            }
        },
        isSyncable() { // 是否可同步抛出
            const currentAccount = this.accountList.find(item => item.accountID === this.currentIndex);
            this.$emit('isSyncable', currentAccount.disabled);
        },
        move(direction) {
            const step = 500;
            const list = document.getElementsByClassName('v-card-picker__list')[0];
            switch (direction) {
            case 'left': list.scrollLeft += step;break;
            case 'right': list.scrollLeft -= step;break;
            }
        },
        init() {
            this.accountList = window.data.data.accountList || [];
            this.accountID = `${window.data.data.accountID}`;
            this.currentIndex = this.accountID;
            this.preIndex = this.accountID;
            this.accountList.forEach((item) => {
                item.typeName = this.accountName(item);
                item.value = item.accountID;
            });
            this.pageType = window.data.data.pageType || 0;
            this.sslDomain = (window.locals && window.locals.sslDomain) || 'bqq.gtimg.com';
            this.qqImg = `//+${this.sslDomain}+/qidian/src/themes/blue/mp/account/images/QQdefault.png`,
            this.wxImg = `//+${this.sslDomain}+/qidian/src/themes/blue/mp/account/images/weixindefault.png`;
            this.enabledLen = 0;
            for (let i = 0, l = this.accountList.length; i < l; i++) {
                this.accountList[i].disabled = !this.getEnabledCond(this.accountList[i]);
                this.accountList[i].enabledCond = !this.accountList[i].disabled;
                if (this.accountList[i].enabledCond) {
                    this.enabledLen += 1;
                }
            }
            this.asynButtonDisabled = !(this.accountList.length > 1);
            Object.keys(replyUrl).forEach((item) => {
                if (window.location.pathname.indexOf(item) !== -1) {
                    this.replySyncUrl = replyUrl[item];
                }
            });
            this.$emit('input', this.accountList.find(item => (+item.accountID === +this.currentIndex)));
        },
        handlerSelect(value) {
            if (value.value !== this.preIndex) {
                window.location.search = `?accountID=${value.value}`;
            }
        },
        accountName(accountObj) {
            const type = +accountObj.type === 1 ? this.$t('微信') : this.$t('QQ');
            const accountType = +accountObj.accountType === 1 ? this.$t('订阅号') : this.$t('服务号');
            return type + accountType;
        },
        getEnabledCond(accountListItem) {
            return +this.pageType === 1 || (+this.pageType === 0  && (+accountListItem.type === 2
                || (+accountListItem.type === 1 && +accountListItem.verifyType > 0)));
        },
        handleSynch(e) {
            e.preventDefault();
            if (!this.params.to.length) {
                this.$message.error(this.$t('请选择需要同步的公众号'));
            } else {
                this.updateOfficial = true;
            }
        },
        synchronizationConfirm() {
            this.updateLoading = true;
            this.$ajax.update(this.replySyncUrl, this.params, {
                headers: {
                    'Content-Type': 'application/json',
                },
                transformRequest: [
                    data => JSON.stringify(data),
                ],
            }).then((res) => {
                if (!res.code) {
                    this.updateLoading = false;
                    this.synchronization = false;
                    this.updateSucessData = res;
                    if (res.succ.length > 0 && res.error.length > 0) {
                        this.allStatus = 0;      // 同时有同步成功和失败情况
                    } else if (res.succ.length > 0 && res.error.length === 0) {
                        this.allStatus = 1;      // 全部成功
                    } else if (res.succ.length === 0 && res.error.length > 0) {
                        this.allStatus = 2;      // 全部失败
                    }
                    this.success = true;
                } else {
                    this.$message.error(res.message || this.$t('同步失败，请稍后重试'));
                    this.updateLoading = false;
                }
            })
                .catch((err) => {
                    this.updateLoading = false;
                    this.$message.error(err.message || this.$t('同步失败，请稍后重试'));
                });
        },
        changeSynchronization(val) {
            const currentVal = this.accountList.find(item => (+item.accountID === +this.currentIndex));
            this.params.from = {
                id: this.currentIndex,
                type: currentVal.type,
            };
            const paramsTo = [];
            val.option.forEach((item) => {
                const obj = {
                    id: item.accountID,
                    type: item.type,
                };
                paramsTo.push(obj);
            });
            this.params.to = paramsTo;
        },
    },
};
</script>

<style lang="less" scoped></style>

<style lang="less">
    @media screen {
        @media (max-width: 1340px) {
        }
    }
    .wx-account-manage {
        display: flex;
        align-items: center;
        cursor: pointer;
        z-index: 10;
        .hidden{
            display: none;
        }
        .arrow-container {
            width: 30px;
            height: 50px;
            display: flex;
            align-items: center;
            color: #A8ABB3;
            &:hover {
                color: #1e2330;
            }
        }
        .arrow_left {
            justify-content: center;
            .arrow_icon_left {
                margin-left: 8px;
            }
            border-right: 1px solid #DADEE7;
        }
        .arrow_right {
            .arrow_icon_right {
                transform:rotate(180deg);
            }
            border-left: 1px solid #DADEE7;
        }
        .wx-account-list {
            display: flex;
            width: 100%;
            align-items: center;
            .wx-account-list-icon{
                width: 32px;
                height: 67px;
                z-index: 9;
                .v-button{
                    margin: 21.5px 4px;
                }
            }
            .wx-account-list-icon-right{
                box-shadow: -1px 0px 1px -1px rgba(18, 19, 25, 0.08), -4px 0px 4px -4px rgba(18, 19, 25, 0.08),
                -12px 0px 12px -12px rgba(18, 19, 25, 0.12);
            }
            .wx-account-list-icon-left{
                box-shadow: 1px 0px 1px -1px rgba(18, 19, 25, 0.08), 4px 0px 4px -4px rgba(18, 19, 25, 0.08),
                12px 0px 12px -12px rgba(18, 19, 25, 0.12);
            }
            .wx-account-list-refresh{
                height: 32px;
                white-space: nowrap;
            }
            .account-scroll-list {
                margin-top: 10px;
                .v-card-picker__list{
                    scroll-behavior: smooth;
                    display: flex;
                    max-height: 85px;
                    flex-wrap: nowrap;
                    overflow: scroll;
                    margin-left: 0px;
                    scrollbar-width: none;
                    .v-card-picker__item:first-child{
                        margin-left: 0px;
                    }
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .v-card-picker__item{
                        margin:0 0 0 var(--spacing-loose);
                    }
                }
                .account-item {
                    display: flex;
                    align-items: center;
                    position: relative;
                    .account-item-avator{
                        width: 32px;
                        height: 32px;
                        position: absolute;
                        .avator-mask{
                            position: absolute;
                            display: inline-block;
                            width: 32px;
                            height: 32px;
                            z-index: 2;
                            border-radius: 50px;
                            background: var(--color-overlay);
                            opacity: 0.8;
                            right: 0px;
                        }
                    }
                    img {
                        width: 32px;
                        height: 32px;
                        border-radius: 100%;
                        overflow: hidden;
                    }
                    .account-info {
                        margin-left: var(--spacing-base);
                        text-align: left;
                        .account-text{
                            height: 20px;
                            .account-name {
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                display: inline-block;
                                width: 116px;
                                // max-width: 110px;
                                font: var(--body-regular);
                                color: var(--color-text-primary);
                                line-height: 20px;
                                overflow: hidden;
                            }
                        }
                        .account-type {
                            color: var(--color-text-caption);
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            display: inline-block;
                            // max-width: 110px;
                            width: 116px;
                            overflow: hidden;
                            font: var(--caption-regular);
                        }
                    }
                }

                .active {
                    border-color: var(--color-primary-normal);
                }

                .active:hover {
                    border-color: var(--color-primary-hover);
                }
            }
            &::-webkit-scrollbar {
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-thumb {
                background-color: var(--color-bg-0);
                border-radius: 14px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background-color: var(--color-opacity-3);
            }
            &::-webkit-scrollbar-track-piece {
                background-color: transparent;
            }
        }
        .account-action {
            width: 131px;
            height: 50px;
            box-sizing: border-box;
            border-left: 1px solid #DADEE7;
            display: flex;
            align-items: center;
            justify-content: center;
            .v-icon {
                width: 15px;
                height: 15px;
            }
            span {
                margin-left: 8px;
            }
        }
    }
    .synchDialog.is-open{
        z-index: 1998;
        .v-modalDialog__body{
            margin-bottom: 16px;
        }
    }
</style>
